module.exports = __webpack_public_path__ + "img/signal-catch.a9a4b193.svg";